<template>
  <div class="accordion">
    <button
      type="button"
      :id="`${title}-accordion-header`"
      :aria-expanded="isOpen"
      :aria-controls="`${title}-accordion-body`"
      class="clear button header text-normal"
      @click.prevent="isOpen = !isOpen"
    >
      <span class="h4">{{ title }}</span>
      <i aria-hidden="true" class="bi bi-chevron-up chevron-animation" :class="{ open: isOpen }"></i>
    </button>
    <transition
      name="expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
      :duration="{ enter: 380, leave: 320 }"
    >
      <div v-show="isOpen" class="body" :id="`${title}-accordion-body`" :aria-labelledby="`${title}-accordion-header`">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>
<script lang="ts">
/* eslint-disable vue/no-setup-props-destructure */
import { defineComponent, PropType, ref } from 'vue'

export default defineComponent({
  name: 'Accordion',
  props: {
    title: {
      type: String as PropType<string>,
      required: true,
    },
    open: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup({ open }) {
    const isOpen = ref(false)
    if (open) {
      isOpen.value = open
    }

    // Transition hooks
    function enter(el: HTMLElement) {
      el.style.height = 'auto'
      const height = getComputedStyle(el).height
      el.style.height = '0'
      el.style.overflow = 'hidden'

      getComputedStyle(el)
      setTimeout(() => {
        el.style.height = height
      })
    }

    function afterEnter(el: HTMLElement) {
      el.style.height = 'auto'
      el.style.overflow = 'auto'
    }

    function leave(el: HTMLElement) {
      el.style.height = getComputedStyle(el).height
      el.style.overflow = 'hidden'
      getComputedStyle(el)
      setTimeout(() => {
        el.style.height = '0'
      })
    }

    return { isOpen, enter, afterEnter, leave }
  },
})
</script>
<style lang="scss" scoped>
// Expand Transition
.expand-enter-active,
.expand-leave-active {
  transition: height 0.5s ease-in-out;
  overflow: hidden;
}

.button.header {
  margin: 0;
}
</style>
